import { ReactNode } from 'react';
import type { PageProps } from 'keycloakify/login/pages/PageProps';

import type { I18n } from '../../i18n';
import type { KcContext } from '../../KcContext';
import { useLoginConsents } from '../LoginSelectForm/hooks';
import { MobileNumberForm } from './components/MobileNumberForm/MobileNumberForm';

export default function LoginUsername(
	props: PageProps<Extract<KcContext, { pageId: 'login-username.ftl' }>, I18n>,
) {
	const { kcContext, i18n, doUseDefaultCss, Template, classes } = props;

	const { realm, url, registrationDisabled, messagesPerField } = kcContext;

	const { msg, msgStr } = i18n;

	const { checkedConsents } = useLoginConsents();

	const getHeaderNode = (): ReactNode => {
		return msgStr('loginHeader');
	};

	const getFormContent = () => {
		return (
			<MobileNumberForm
				backUrl={url.loginRestartFlowUrl}
				checkedConsents={checkedConsents}
				{...props}
			/>
		);
	};

	return (
		<Template
			kcContext={kcContext}
			i18n={i18n}
			doUseDefaultCss={doUseDefaultCss}
			classes={{
				...classes,
				kcFormCardClass: 'gray',
				kcBodyClass: 'gray',
			}}
			displayMessage={!messagesPerField.existsError('username')}
			headerNode={getHeaderNode()}
			displayInfo={realm.password && realm.registrationAllowed && !registrationDisabled}
			infoNode={
				<div id="kc-registration-container">
					<div id="kc-registration">
						<span>
							{msg('noAccount')}
							<a tabIndex={6} href={url.registrationUrl}>
								{msg('doRegister')}
							</a>
						</span>
					</div>
				</div>
			}
		>
			<div id="kc-form">
				<div id="kc-form-wrapper" className="kcFormWrapper">
					{getFormContent()}
				</div>
			</div>
		</Template>
	);
}
